var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimpleForm, useEditController, Toolbar, SaveButton, useNotify, TextInput } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export var SettingsIntegrations = function () {
    var tenantId = useTenantStore()[0];
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var notify = useNotify();
    var authContext = useContext(AuthContext);
    var _b = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _b.record, save = _b.save, isLoading = _b.isLoading;
    var canEdit = authContext.isAuthorized(true, authContext.tenantId, [
        IPermissions.TENANT_WRITE,
    ]);
    var _c = useState(null), gapiKey = _c[0], setGapiKey = _c[1];
    var _d = useState(""), gapiEmail = _d[0], setGapiEmail = _d[1];
    var _e = useState(false), gapiKeyChanged = _e[0], setGapiKeyChanged = _e[1];
    var _f = useState(false), gapiEmailChanged = _f[0], setGapiEmailChanged = _f[1];
    var _g = useState(true), saveDisabled = _g[0], setSaveDisabled = _g[1];
    useEffect(function () {
        if (gapiKeyChanged || gapiEmailChanged) {
            setSaveDisabled(false);
        }
        else {
            setSaveDisabled(true);
        }
    }, [gapiKeyChanged, gapiEmailChanged]);
    var handleGapiKeyChange = function (event) {
        var inputValue = event.target.value;
        try {
            var parsedGapiKey = !inputValue || inputValue.trim().length === 0 ? null : JSON.parse(inputValue);
            if (typeof parsedGapiKey === "object" && parsedGapiKey !== null) {
                setGapiKey(parsedGapiKey);
                setGapiKeyChanged(true);
            }
            else if (parsedGapiKey === null) {
                setGapiKey(null);
                setGapiKeyChanged(true);
            }
            else {
                notify(t("integrationsScreen.errors.invalidGapiKey"), { type: "error" });
            }
        }
        catch (error) {
            notify(t("integrationsScreen.errors.invalidGapiKey"), { type: "error" });
        }
    };
    var handleGapiEmailChange = function (event) {
        var inputValue = event.target.value;
        setGapiEmail(inputValue);
        setGapiEmailChanged(true);
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedSettings;
        var _a;
        return __generator(this, function (_b) {
            updatedSettings = __assign({}, ((_a = record === null || record === void 0 ? void 0 : record.settings) !== null && _a !== void 0 ? _a : {}));
            // Only update fields that have been changed
            if (gapiKeyChanged) {
                updatedSettings.gapi_key = gapiKey;
            }
            if (gapiEmailChanged) {
                updatedSettings.gapi_email = gapiEmail.trim() !== "" ? gapiEmail : undefined;
            }
            save({
                settings: updatedSettings,
            });
            // Clear the inputs and reset change flags after saving
            setGapiKey(null);
            setGapiEmail("");
            setGapiKeyChanged(false);
            setGapiEmailChanged(false);
            return [2 /*return*/];
        });
    }); };
    if (isLoading)
        return null;
    return (_jsxs(SimpleForm, { toolbar: _jsx(Toolbar, { children: canEdit ? (_jsx(SaveButton, { onClick: function () {
                    onSave();
                }, type: "button", disabled: saveDisabled })) : null }), children: [_jsx(TextInput, { multiline: true, maxRows: 6, source: "settings.gapi_key", label: String(t("integrationsScreen.common.gapiKey")), onChange: handleGapiKeyChange }), _jsx(TextInput, { source: "settings.gapi_email", label: String(t("integrationsScreen.common.gapiEmail")), onChange: handleGapiEmailChange })] }));
};
